import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';

const DashboardCardOrdersValue = ({ orders }) => {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
  const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

  const calculateOrderValue = (orders, timeFrame) => {
    return orders.reduce((total, order) => {
      const orderDate = new Date(order.property_date);
      
      switch(timeFrame) {
        case 'thisMonth':
          if (orderDate.getMonth() === currentMonth && 
              orderDate.getFullYear() === currentYear) {
            return total + parseFloat(order.order_total);
          }
          break;
        case 'lastMonth':
          if (orderDate.getMonth() === lastMonth && 
              orderDate.getFullYear() === lastMonthYear) {
            return total + parseFloat(order.order_total);
          }
          break;
        case 'year':
          if (orderDate.getFullYear() === currentYear) {
            return total + parseFloat(order.order_total);
          }
          break;
        case 'last_year':
          if (orderDate.getFullYear() === currentYear - 1) {
            return total + parseFloat(order.order_total);
          }
          break;
      }
      return total;
    }, 0);
  };

  const thisMonthValue = calculateOrderValue(orders, 'thisMonth');
  const lastMonthValue = calculateOrderValue(orders, 'lastMonth');
  const yearValue = calculateOrderValue(orders, 'year');
  const last_year = calculateOrderValue(orders, 'last_year');
  const maxValue = Math.max(thisMonthValue, lastMonthValue, yearValue, last_year);
  const totalValue =  yearValue + last_year;

  const ProgressBar = ({ value, maxValue, color }) => (
    <div className="w-full bg-gray-200 rounded-full h-2">
      <div 
        className={`${color} h-2 rounded-full transition-all duration-500`}
        style={{ width: `${(value/maxValue) * 100}%` }}
      />
    </div>
  );

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center mb-6">
        <FaShoppingCart className="text-golden-navy mr-2 text-xl" />
        <h3 className="text-lg font-semibold text-golden-navy">Order Value</h3>
      </div>
      
      <div className="grid grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-4">
          <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">This Month</span>
              <span className="text-sm font-semibold text-emerald-600">£{thisMonthValue.toFixed(2)}</span>
            </div>
            <ProgressBar value={thisMonthValue} maxValue={maxValue} color="bg-emerald-500" />
          </div>
      
          <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">This Year</span>
              <span className="text-sm font-semibold text-purple-600">£{yearValue.toFixed(2)}</span>
            </div>
            <ProgressBar value={yearValue} maxValue={maxValue} color="bg-purple-500" />
          </div>
         
        </div>

        {/* Right Column */}
        <div className="space-y-4">
        <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">Last Month</span>
              <span className="text-sm font-semibold text-blue-600">£{lastMonthValue.toFixed(2)}</span>
            </div>
            <ProgressBar value={lastMonthValue} maxValue={maxValue} color="bg-blue-500" />
          </div>
          <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">Last Year</span>
              <span className="text-sm font-semibold text-orange-600">£{last_year.toFixed(2)}</span>
            </div>
            <ProgressBar value={last_year} maxValue={maxValue} color="bg-orange-500" />
          </div>
      
       
        </div>
      </div>

      {/* Total Section */}
      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <span className="text-base font-semibold">Total Value</span>
          <span className="text-lg font-bold text-gray-900">£{totalValue.toFixed(2)}</span>
        </div>
        <ProgressBar value={totalValue} maxValue={totalValue} color="bg-golden-yellow" />

      </div>
    </div>
  );
};

export default DashboardCardOrdersValue;